import { orderBy } from "lodash-es";
import type { BillingConfigPrices } from "../../types";

export function sortPrices(prices: BillingConfigPrices): BillingConfigPrices {
  return orderBy(prices, [(price) => price.type], ["asc"]);
}
